export enum MaintenanceChannel {
  CREATE = 'maintenance::create',
  EDIT = 'maintenance::patch',
  DELETE = 'maintenance::delete',
}
